import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Profil from '@/views/Profil.vue'
import Tupoksi from '@/views/Tupoksi.vue'
import Struktur from '@/views/Struktur.vue'
import Visi from '@/views/Visi.vue'
import Pejabat from '@/views/Pejabat.vue'
import Berita from '@/views/Berita.vue'
import DetailBerita from '@/views/DetailBerita.vue'
import Pengumuman from '@/views/Pengumuman.vue'
import Data from '@/views/Data.vue'
import Dokumen from '@/views/Dokumen.vue'
import Peraturan from '@/views/Peraturan.vue'
import Foto from '@/views/Foto.vue'
import Video from '@/views/Video.vue'
import Sekretariat from '@/views/Sekretariat.vue'
import Kualitas from '@/views/Kualitas.vue'
import Pemenuhan from '@/views/Pemenuhan.vue'
import Perlindungan from '@/views/Perlindungan.vue'
import Pengaduan from '@/views/Pengaduan.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/profil',
    name: 'profil',
    component: Profil
  },
  {
    path: '/tupoksi',
    name: 'tupoksi',
    component: Tupoksi
  },
  {
    path: '/struktur',
    name: 'struktur',
    component: Struktur
  },
  {
    path: '/visi',
    name: 'visi',
    component: Visi
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: Sekretariat
  },
  {
    path: '/kualitas',
    name: 'kualitas',
    component: Kualitas
  },
  {
    path: '/perlindungan',
    name: 'perlindungan',
    component: Perlindungan
  },
  {
    path: '/pemenuhan',
    name: 'pemenuhan',
    component: Pemenuhan
  },
  {
    path: '/pejabat',
    name: 'pejabat',
    component: Pejabat
  },
  {
    path: '/berita',
    name: 'berita',
    component: Berita
  },
  {
    path: '/detail_berita',
    name: 'detail_berita',
    component: DetailBerita
  },
  {
    path: '/pengumuman',
    name: 'pengumuman',
    component: Pengumuman
  },
  {
    path: '/data',
    name: 'data',
    component: Data
  },
  {
    path: '/peraturan',
    name: 'peraturan',
    component: Peraturan
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: Dokumen
  },
  {
    path: '/pengaduan',
    name: 'pengaduan',
    component: Pengaduan
  },
  {
    path: '/foto',
    name: 'foto',
    component: Foto
  },
  {
    path: '/video',
    name: 'video',
    component: Video
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
